import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import * as actions from '../actions'
import { Card, Row } from 'react-bootstrap'
import { Button, Dialog } from '@material-ui/core'
import DialogView from '../../Dialogos/DialogView'
import Alert from '@material-ui/lab/Alert'
import { LOGIN_FORM } from '../../../config/forms'
import { RUTA_USUARIO } from '../../../config/ruta_usuario'
import { reduxForm, Field, formValueSelector, isInvalid, isSubmitting } from 'redux-form'
import { renderTextField } from '../../Forms/fieldRenderers'
import { required } from '../../Forms/fieldValidators'
import HeaderApp from '../../LaridaeApp/components/HeaderApp'
import { COLORES } from '../../../config/colores'
import FormularioSolicitudUsuario from '../components/FormularioSolicitudUsuario'

function Login (props) {
  const { history, authenticated, autoLogin, errorMessage, invalid, submitting } = props
  const [openForm, setOpenForm] = useState(false)

  useEffect(() => {
    autoLogin(history)
    if (authenticated) history.push(``)
  }, [autoLogin, history, authenticated])

  const handleLoginClick = () => {
    const { username, password } = props
    const options = {
      history: history,
      redirectTo: RUTA_USUARIO[username] ? RUTA_USUARIO[username].redirectTo : ``
    }
    props.loginUser(username, password, options)
  }

  const handleOpenForm = () => {
    console.log('open dialog, open form')
    setOpenForm(true)
  }

  const handleCloseForm = () => { setOpenForm(false) }

  return (
    <div style={{ height: '88vh' }}>
      <div className='App-header-panel'>
        <HeaderApp />
      </div>

      <Dialog
        open={openForm}
        onClose={handleCloseForm}
        maxWidth='lg'
        fullScreen
      >
        <DialogView
          cancelCallback={handleCloseForm}
          title='Solicitud de acceso a Laridae'
          content={<FormularioSolicitudUsuario handleCloseForm={handleCloseForm} />}
        />
      </Dialog>

      <div className='login'>
        <div className='row justify-content-center container-login'>
          <div className='d-flex p-4 align-items-center justify-content-center h-100'>
            <Card className='shadow bg-white rounded' style={{ width: '18rem' }}>
              <Card.Header as='h4' style={{ fontWeight: 'bold', backgroundColor: '#cfcfcf0', color: COLORES.grey.dark }}>
                Iniciar Sesión
              </Card.Header>
              <form onSubmit={handleLoginClick}>
                <Card.Body>
                  <Field className='textLine'
                    name='username'
                    type='text'
                    label='Usuario'
                    component={renderTextField}
                    autoFocus
                    placeholder='nombre de usuario ej.: dperez'
                  />
                  <Field className='textLine'
                    name='password'
                    label='Contraseña'
                    type='password'
                    component={renderTextField}
                    autoFocus={false}
                    validate={[required]}
                    placeholder='contraseña de acceso'
                  />
                  {errorMessage && (
                    <div style={{ margin: '2% 0' }}>
                      <Alert variant='filled' severity='error'>
                        {errorMessage}
                      </Alert>
                    </div>
                  )}

                  <div style={{ margin: '22px 0' }}>
                    <Button
                      onClick={handleOpenForm}
                      size='small'
                      variant='text'
                      color='primary'
                      style={{ outline: 'none' }}
                    >
                        ¿No tienes usuario en Laridae?
                    </Button>
                    <p style={{ fontSize: '0.9rem', marginTop: 0, paddingTop: 0 }}>Complete y envíenos el formulario.</p>
                  </div>

                  <Row className='d-flex align-items-center justify-content-center'>
                    <Button
                      style={{ color: '#ffffff', width: '90%' }}
                      onClick={handleLoginClick}
                      size='small'
                      type='submit'
                      variant='containedPrimary'
                      disabled={invalid || submitting}
                    >
                      Ingresar
                    </Button>
                  </Row>
                </Card.Body>
              </form>
            </Card>
          </div>
        </div>
      </div>
    </div>
  )
}

const selector = formValueSelector(LOGIN_FORM)

const mapStateToProps = (state) => ({
  authenticated: state.auth.authenticated,
  showModal: state.auth.showLoginModal,
  errorMessage: state.auth.errorMessage,
  username: selector(state, 'username'),
  password: selector(state, 'password'),
  submitting: isSubmitting(LOGIN_FORM)(state),
  invalid: isInvalid(LOGIN_FORM)(state)
})

const withRedux = connect(mapStateToProps, actions)

export default withRedux(
  reduxForm({ form: LOGIN_FORM })(Login)
)
